module.exports = __webpack_public_path__ + "img/calendar-regular.bf0b706b.svg";